// "Why Clients Work With Hallie" — trust signals.

import { Clock, Workflow, ListChecks, Heart, ShieldCheck, TrendingUp } from 'lucide-react';

export const WHY_HALLIE = [
  {
    icon: Clock,
    title: '15+ Years of Experience',
    body: 'A decade-and-a-half of supporting service businesses across operations, customer experience, and business growth.',
  },
  {
    icon: Workflow,
    title: 'Operations-Focused',
    body: 'Calm, structured systems that remove friction from day-to-day work and reduce mental load on owners.',
  },
  {
    icon: ListChecks,
    title: 'Systems-Oriented',
    body: 'Every engagement leaves the business with documented processes the team can actually use.',
  },
  {
    icon: Heart,
    title: 'Client-Centered',
    body: 'Your customers experience the consistency that earns repeat work and referrals.',
  },
  {
    icon: ShieldCheck,
    title: 'Reliable Execution',
    body: 'Ownership of outcomes, not just task lists. Things get done — quietly and on time.',
  },
  {
    icon: TrendingUp,
    title: 'Process Improvement Mindset',
    body: 'Always refining. The systems we build today are reviewed and improved as the business grows.',
  },
];

// Business outcome statements — qualitative only (per project brief).
export const BUSINESS_OUTCOMES = [
  'Improved customer communication',
  'Streamlined scheduling processes',
  'Implemented CRM workflows',
  'Reduced operational bottlenecks',
  'Built systems that support growth',
  'Created scalable processes',
  'Faster, more consistent client follow-up',
  'Clearer ownership across the team',
];

// Discovery Call Funnel — 5 steps.
export const FUNNEL_STEPS = [
  { step: '01', title: 'Submit Inquiry', body: 'Share a little about your business and what is feeling stuck through the contact form.' },
  { step: '02', title: 'Discovery Call', body: 'A short, focused conversation to understand the shape of the work and the support you need.' },
  { step: '03', title: 'Recommendations', body: 'A written recommendation tailored to your business, with a clear scope and engagement model.' },
  { step: '04', title: 'Proposal', body: 'A plain-English proposal you can review and approve. No surprises, no pressure.' },
  { step: '05', title: 'Implementation', body: 'Onboarding, setup, and steady delivery of the work, with weekly written updates.' },
];
